import * as React from 'react';
import GeneratorContext from './GeneratorContext';
import GeneratorSection from './components/GeneratorSection';

import { Provider } from 'react-redux';
import { getStore } from '@Utils/core/redux/appStore';

const store = getStore();

const Generator: React.FC = () => {
  const [genderGroup, setGenderGroup] = React.useState('');
  const [generatedNickname, setGeneratedNickname] = React.useState('');
  const [isGenerated, setIsGenerated] = React.useState(false);
  const [showErrorMessage, setShowErrorMessage] = React.useState(false);
  const [isCopied, setIsCopied] = React.useState(false);
  const [avatarInput, setAvatarInput] = React.useState('');

  /**
   * Add class to body when nickname is generated
   */
  React.useEffect(() => {
    if (isGenerated) {
      document.body.classList.add('plarium-nickname-generated');
    } else {
      document.body.classList.remove('plarium-nickname-generated');
    }
  }, [isGenerated]);

  return (
    <Provider store={store}>
      <GeneratorContext.Provider
        value={{
          genderGroup: genderGroup,
          setGenderGroup: setGenderGroup,
          generatedNickname: generatedNickname,
          setGeneratedNickname: setGeneratedNickname,
          isGenerated: isGenerated,
          setIsGenerated: setIsGenerated,
          showErrorMessage: showErrorMessage,
          setShowErrorMessage: setShowErrorMessage,
          isCopied: isCopied,
          setIsCopied: setIsCopied,
          avatarInput: avatarInput,
          setAvatarInput: setAvatarInput,
        }}
      >
        <GeneratorSection />
      </GeneratorContext.Provider>
    </Provider>
  );
};

export default Generator;
